import { useSubjectsTree } from '@ts-core/modules/subjects/components/SubjectsTree';

export default function useSubjectsPanel({
  subjects,
  selectedSubjectId,
  loading,
  error,
  showSelectedMark = false,
  addingSubject,
  editingSubject,
  onSelectLeafSubject,
  onAddSubject,
  onEditSubject,
  onRemoveSubject,
  onToggleSubject,
  onReorderSubject,
}) {
  const {
    isSubjectOpen,
    isSubjectSelected,
    onToggleSubject: onToggleSubjectOpen,
  } = useSubjectsTree({ onSelectLeafSubject, selectedSubjectId, subjects });

  return {
    loading,
    subjects,
    showSelectedMark,
    error,

    isSubjectOpen,
    isSubjectSelected,
    addingSubject,
    editingSubject,

    onSelectSubject: onToggleSubjectOpen,
    onEditSubject,
    onAddSubject,
    onRemoveSubject,
    onToggleSubject,
    onReorderSubject,
  };
}
